import { types } from "./actionTypes";
export const FetchLoadOptimizationData = (values,callback) => ({
  type: types.LOAD_OPTIMIZATION_DATA,
  values,
  callback,
});


